import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'item-no-content',
	templateUrl: './item-no-content.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class ItemNoContentComponent implements OnInit {
	
	@Input() isFluid: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		
	}
	
}